import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { PriceTicker } from './components/PriceTicker';
import { Footer } from './components/Footer';
import { AdSenseScript } from './components/AdSense';
import { CookieBanner } from './components/CookieBanner';
import { HomePage } from './pages/HomePage';
import { ArticlePage } from './pages/ArticlePage';
import { AboutPage } from './pages/AboutPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { ContactPage } from './pages/ContactPage';
import { ArbitragePage } from './pages/ArbitragePage';
import { GlossarioPage } from './pages/GlossarioPage';
import { GlossarioTermPage } from './pages/GlossarioTermPage';
import { PoliticaEditorialPage } from './pages/PoliticaEditorialPage';
import { PoliticaCorrecoesPage } from './pages/PoliticaCorrecoesPage';
import { AutoresPage } from './pages/AutoresPage';
import { ResumoDiarioPage } from './pages/ResumoDiarioPage';
import { AprendaPage } from './pages/AprendaPage';
import { ArcadePage } from './pages/arcade/ArcadePage';
import { QuizDiarioPage } from './pages/arcade/QuizDiarioPage';
import { CryptoWordPage } from './pages/arcade/CryptoWordPage';
import { CandleChallengePage } from './pages/arcade/CandleChallengePage';
import { PerfilPage } from './pages/arcade/PerfilPage';
import { GuiaPage } from './pages/GuiaPage';
import { OportunidadesPage } from './pages/OportunidadesPage';
import { OportunidadePage } from './pages/OportunidadePage';
import { FerramentasPage } from './pages/tools/FerramentasPage';
import { CalculadoraDcaPage } from './pages/tools/CalculadoraDcaPage';
import { CalculadoraLucroPage } from './pages/tools/CalculadoraLucroPage';
import { ConversorPage } from './pages/tools/ConversorPage';
import { CalculadoraStakingPage } from './pages/tools/CalculadoraStakingPage';
import { GasPage } from './pages/tools/GasPage';
import { ComparadorExchangesPage } from './pages/tools/ComparadorExchangesPage';
import { AutorPage } from './pages/AutorPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';

function AppContent() {
  useGoogleAnalytics();

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <PriceTicker />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:slug" element={<ArticlePage />} />
          <Route path="/category/:slug" element={<HomePage />} />
          <Route path="/tag/:slug" element={<HomePage />} />
          <Route path="/trending" element={<HomePage />} />
          <Route path="/resumo-diario" element={<ResumoDiarioPage />} />
          <Route path="/resumo-diario/:date" element={<ResumoDiarioPage />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/politica-editorial" element={<PoliticaEditorialPage />} />
          <Route path="/politica-de-correcoes" element={<PoliticaCorrecoesPage />} />
          <Route path="/autores" element={<AutoresPage />} />
          <Route path="/autores/:slug" element={<AutorPage />} />
          <Route path="/privacy-policy" element={<Navigate to="/politica-de-privacidade" replace />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicyPage />} />
          <Route path="/termos-de-uso" element={<TermsOfUsePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/arbitrage" element={<ArbitragePage />} />
          <Route path="/arcade" element={<ArcadePage />} />
          <Route path="/arcade/quiz-diario" element={<QuizDiarioPage />} />
          <Route path="/arcade/crypto-word" element={<CryptoWordPage />} />
          <Route path="/arcade/candle-challenge" element={<CandleChallengePage />} />
          <Route path="/arcade/perfil" element={<PerfilPage />} />
          <Route path="/aprenda" element={<AprendaPage />} />
          <Route path="/aprenda/:slug" element={<GuiaPage />} />
          <Route path="/oportunidades" element={<OportunidadesPage />} />
          <Route path="/oportunidades/:slug" element={<OportunidadePage />} />
          <Route path="/ferramentas" element={<FerramentasPage />} />
          <Route path="/ferramentas/calculadora-dca" element={<CalculadoraDcaPage />} />
          <Route path="/ferramentas/calculadora-de-lucro" element={<CalculadoraLucroPage />} />
          <Route path="/ferramentas/conversor" element={<ConversorPage />} />
          <Route path="/ferramentas/calculadora-staking" element={<CalculadoraStakingPage />} />
          <Route path="/ferramentas/gas" element={<GasPage />} />
          <Route path="/ferramentas/comparador-exchanges" element={<ComparadorExchangesPage />} />
          <Route path="/ferramentas/arbitragem" element={<Navigate to="/arbitrage" replace />} />
          <Route path="/glossario" element={<GlossarioPage />} />
          <Route path="/glossario/:slug" element={<GlossarioTermPage />} />
          <Route path="/about" element={<Navigate to="/sobre" replace />} />
          <Route path="/categories" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AdSenseScript />
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
